import { useEffect } from 'react';

export const ClarityScript = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.clarity =
        window.clarity ||
        function () {
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/r1v0t6tt0u';
      document.head.appendChild(script);
    }
  }, []);

  return null;
};
